module.exports = __webpack_public_path__ + "static/img/1.68174e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka2/1.jpg
// module id = qIud
// module chunks = 16